import { Artwork } from "@/interfaces/artwork.interface";
import ArtworkList from "./ArtworkList";
import { ReactNode } from "react";

interface ArtworkFilter {
  name?: string;
}

interface Props {
  filter?: ArtworkFilter;
  header?: ReactNode;
  onChange?: (artwork?: Artwork) => void;
  onSelect?: (artwork: Artwork) => void;
  onRemove?: (artwork: Artwork) => void;
}

export default function ArtworkManagement({
  filter,
  header,
  onChange,
  onSelect,
  onRemove,
}: Props) {
  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full flex-1 overflow-auto">
        <ArtworkList
          filter={filter}
          header={header}
          onChange={onChange}
          onSelect={onSelect}
          onRemove={onRemove}
        />
      </div>
    </div>
  );
}
